export const ROLE_LABEL = {
    owner: "Owner",
    admin: "Admin",
    member: "Member",
};

export const ROLE_DESC = {
    owner: "Full access. Can manage members, pools, payouts.",
    admin: "Can manage pools, approve payouts, invite members.",
    member: "View pools, receive payouts, update own banking.",
};

export const can = {
    invite: (role) => ["owner", "admin"].includes(role),
    createPool: (role) => ["owner", "admin"].includes(role),
    editPercentages: (role) => ["owner", "admin"].includes(role),
    executePayout: (role) => ["owner", "admin"].includes(role),
    approve: (role) => ["owner", "admin"].includes(role),
    removeMember: (role) => ["owner", "admin"].includes(role),
    createInvoice: (role) => ["owner", "admin"].includes(role),
    deletePool: (role) => ["owner", "admin"].includes(role),
    manageBilling: (role) => role === "owner",
    connectStripe: (role) => role === "owner",
};
